import React from "react";
import styled from "styled-components";
import ServiceSection from "./components/ServiceSection";
import ProgressSection from "../about/components/ProgressSection";

const Wrapper = styled.div``;
function ServicePage() {
  return (
    <Wrapper>
      <ServiceSection />
      <ProgressSection/>
    </Wrapper>
  );
}

export default ServicePage;
